import React, { Component } from "react";
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from "mdbreact";
import BasicButton from "../../SharedComponents/BasicButton/BasicButton";
import BasicTextField from "../../SharedComponents/BasicTextField/BasicTextField";
import BasicCheckbox from "../../SharedComponents/BasicCheckbox/BasicCheckbox";
import BasicLabel from "../../SharedComponents/BasicLabel/BasicLabel";
import CircularProgress from "@material-ui/core/CircularProgress";
import BasicTextArea from "../../SharedComponents/BasicTextArea/BasicTextArea";
import SelectField from "../../SharedComponents/SelectField/SelectField";
import SearchSelectField from "../../SharedComponents/SearchSelectField"
import "./ClearanceRecord.scss";
import { withUserContext } from '../../../contexts/UserContext';
import * as Constants from '../../../constants/constants';
import ClearTrackService from '../../../services/service';
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { initialClearanceRecord, mockSong } from "./config";
import { checkBoxOptionsLeft, checkBoxOptionsRightEdit } from "./config";
import { checkBoxOptionsRight, clearanceWritersList } from "./config";
import messages from '../../../Common/Messages.json';
import axios from 'axios';
import Popover from '@material-ui/core/Popover';
import { validateNumbersOnly } from "../../../Common/Helper";
import { clearanceRecordPermissionsConfig } from "../../EpisodeAndClearence/EpisodeAndClearenceDetails/Config";
import MessageModal from '../../SharedComponents/MessageModal';
import WarningNotesModal from '../../SharedComponents/WarningNotesModal/WarningNotesModal';
import SearchFieldWithAddValue from '../../../components/SharedComponents/SearchFieldWithAddValue';
import EditSongDetails from '../../EpisodeAndClearence/EditSong/EditSongDetails';
import MainViewModalComponent from "../../../Common/MainViewModalLayout/Modal/Modal";
import NotificationComponent from "../../../Common/NotificationComponent/NotificationComponent";
import { closeWarningNotesModal, emptyWarningNotesModal, showCombinedSongWarnings, showEntityWarningNotesWithLookup, registerShownWarningEntities, isWarningEntityAlreadyShown, cancelPendingWarningNotesRequests, showEntityWarningNotesWithLookupIfNeeded } from '../../../Common/warningNotesHelper';

class ClearanceRecord extends Component {
    constructor(props) {
        super(props);
        this.combinedWarningNotesShown = false;
        this.shownWarningEntities = new Set();
        this.pendingEditSongAfterWarning = null;
        this.state = {
            postInitiated: false,
            episodeOptions: [],
            loadingEpisodes: false,
            songOptions: [],
            inActiveSongOptions:[],
            adCardOptions: [],
            searchResult: [],
            seasonOptions: [],
            isFetchingSeason: false,
            showsOptions: [],
            clearanceRecordData: this.formatClearanceDetails(JSON.parse(JSON.stringify({ ...initialClearanceRecord }))),
            useOptions: [],
            checkBoxOptionsLeft: checkBoxOptionsLeft,
            checkBoxOptionsRight: this.props?.mode === 'New' ? [...checkBoxOptionsRight] : [...checkBoxOptionsRightEdit],
            isPosting: false,
            performerOptions: [],
            clearanceOptions: [],
            clearanceRepOptions: [],
            performerList: [],
            songUse: [],
            division_id: null,
            isDataLoading: false,
            searchCancelToken: null,
            isFetchingShow: false,
            isSongFetching: [],
            isPerformerFetching: [],
            customNotes: null,
            deletedSongs: [],
            songListData: [],
            clearanceRecordPermissionsConfig: clearanceRecordPermissionsConfig,
            durationValid: null,
            selectedRestrictedSong: false,
            newSongPopup: false,
            proposedNewSong: null,
            selectSong: null,
            searchSelect: true,
            isSendEmail: false,
            isMusicSupervisorEmail: false,
            isActiveMusicSupervisor: false,
            isMsChecked: "",
            dialogBox: "",
            newSongRowIndex: null,
            loadingSongs:false,
            openInActiveSongModal: false,
            displayAddNewSongOption: false,
            searchedSongString: null,
            searchedSongIndex: null,
            isEditingPerformer: false,
            editingPerformerSongIndex:null,
            newPerformerData: null,   
            isDuplicateSong:false,
            showDuplicateNotification:false,
            writerOptions:[],
            writerList: [],
            deletedWriters: [],   
            writerMode: null,     
            selectedWriterIndex: null, 
            selectedSongIndex: null,
            warningNotesModal: { ...emptyWarningNotesModal },
        };
        this.warningNotesRequestId = 0;
    };

    showEntityWarningNotes = (entityKey, entityId, entityName, warningNotes) => {
        showEntityWarningNotesWithLookup(this, {
            entityKey,
            entityId,
            entityName,
            warningNotes,
            tenantId: this.props.userContext?.active_tenant?.tenant_id,
        });
    };

    handleWarningNotesModalConfirm = () => {
        closeWarningNotesModal(this);
        const pending = this.pendingEditSongAfterWarning;
        if (!pending) return;

        if (pending.type === 'performerThenEditSong') {
            this.pendingEditSongAfterWarning = null;
            this.runPerformerWarningBeforeEditSong(pending);
            return;
        }

        this.pendingEditSongAfterWarning = null;
        this.setState({
            isEditingPerformer: true,
            editingPerformerSongIndex: pending.index,
            newPerformerData: pending.performerData,
        });
    };

    openEditSongForPerformer = (index, performerData) => {
        this.pendingEditSongAfterWarning = null;
        this.setState({
            isEditingPerformer: true,
            editingPerformerSongIndex: index,
            newPerformerData: performerData,
        });
    };

    runPerformerWarningBeforeEditSong = async ({ index, performerData, performerId, performerName, warningNotes }) => {
        const tenantId = this.props.userContext?.active_tenant?.tenant_id;

        if (isWarningEntityAlreadyShown(this, 'performer', performerId)) {
            this.openEditSongForPerformer(index, performerData);
            return;
        }

        if (!this.state.warningNotesModal?.open) {
            cancelPendingWarningNotesRequests(this);
        }

        this.pendingEditSongAfterWarning = { index, performerData };

        const wasShown = await showEntityWarningNotesWithLookupIfNeeded(this, {
            entityKey: 'performer',
            entityId: performerId,
            entityName: performerName,
            warningNotes,
            tenantId,
        });

        if (wasShown) {
            registerShownWarningEntities(this, [{ entityKey: 'performer', entityId: performerId }]);
        } else {
            this.openEditSongForPerformer(index, performerData);
        }
    };

    maybeShowPerformerWarningThenOpenEditSong = (index, performerData, performerId, performerName, warningNotes) => {
        if (this.state.warningNotesModal?.open) {
            this.pendingEditSongAfterWarning = {
                type: 'performerThenEditSong',
                index,
                performerData,
                performerId,
                performerName,
                warningNotes,
            };
            return;
        }

        this.runPerformerWarningBeforeEditSong({ index, performerData, performerId, performerName, warningNotes });
    };

    showPerformerWarningOnClearanceRecord = async (performerId, performerName, warningNotes) => {
        if (isWarningEntityAlreadyShown(this, 'performer', performerId)) return;

        const wasShown = await showEntityWarningNotesWithLookupIfNeeded(this, {
            entityKey: 'performer',
            entityId: performerId,
            entityName: performerName,
            warningNotes,
            tenantId: this.props.userContext?.active_tenant?.tenant_id,
        });

        if (wasShown) {
            registerShownWarningEntities(this, [{ entityKey: 'performer', entityId: performerId }]);
        }
    };
    formatClearanceDetails = (response) => {
        if (response.songs_list?.length === 0) {
            response.songs_list.push(JSON.parse(JSON.stringify({ ...mockSong })))
            return response;
        } else {
            let newSongList = response?.songs_list?.map(item => {
                let newItem = { ...item }
                newItem.selected_song = {
                    'value': item?.song_id,
                    'text': `${item?.song_title}${item?.writer?.length > 0 ? '(' + item?.writer?.map(ele => ele?.writer_name ? ele?.writer_name : '' + ele?.affiliation_name ? '-' + ele?.affiliation_name : '') + ')' : ''}`
                }
                newItem.selected_performer = {
                    'value': item?.performer_id,
                    'text': item?.performer_name
                }
                newItem.min = item?.duration ? item?.duration?.split(":")[0] : null
                newItem.sec = item?.duration ? item?.duration?.split(":")[1] : null
                delete newItem.duration
                return newItem
            })
            response.songs_list = newSongList
            return response
        }
    }

    componentDidMount() {
if(this.props?.clearanceRecordsFilter && this.props.mode === "New"){
            this.setState({clearanceRecordsFilter:this.props?.clearanceRecordsFilter},()=>{
                if(this.state.clearanceRecordsFilter?.selectedShow){
                    this.getSeasons(this.state.clearanceRecordsFilter?.selectedShow?.value,this.props.mode);
                }else{
                    if(this.state.clearanceRecordsFilter?.selectedSeason){
                        this.getEntity("seasonOptions", "SEASON", "null");
                    }
                }
                this.setState((prevState) => ({
                    clearanceRecordData: {
                        ...prevState.clearanceRecordData,
                        ["show_id"]:this.state?.clearanceRecordsFilter?.selectedShow?this.state?.clearanceRecordsFilter?.selectedShow?.value:null,
                        ["season_id"]: this.props.clearanceRecordsFilter?.selectedSeason?this.props.clearanceRecordsFilter?.selectedSeason:null,
                        ["show_season_episode_id"]: this.props.clearanceRecordsFilter?.selectedEpisode?this.props.clearanceRecordsFilter?.selectedEpisode:null,
                        ["selected_show"]:this.props.clearanceRecordsFilter?.selectedShow?this.props.clearanceRecordsFilter?.selectedShow:null,
                        ["show_name"]:this.state?.clearanceRecordsFilter?.selectedShow?this.state?.clearanceRecordsFilter?.selectedShow?.text:null,
                        ["scene"]:this.state?.clearanceRecordsFilter?.scene?this.state?.clearanceRecordsFilter?.scene:null,
                    },
                    division_id: this.props.clearanceRecordsFilter?.selectedShow?.division_id,
                    postInitiated: false
                }),()=>{
                    if(this.props?.clearanceRecordsFilter?.selectedPerformer){
                        this.getEntity("performerOptions", "PERFORMER", "null", this.props.mode);
                    }
                    if(this.props?.clearanceRecordsFilter?.selectedUses){
                        this.getEntity("useOptions", "MUSIC_USES", "",this.props.mode);
                    }
                    let temp_songs_list=JSON.parse(JSON.stringify(this.state?.clearanceRecordData?.songs_list));
                    if(this.props?.clearanceRecordsFilter?.duration){
                        temp_songs_list[0].min = this.props?.clearanceRecordsFilter?.duration?(this.props?.clearanceRecordsFilter?.duration?.includes(" ")|| this.props?.clearanceRecordsFilter?.duration?.includes(":")) ? (Number(this.props?.clearanceRecordsFilter?.duration?.split(" ")[0])||Number(this.props?.clearanceRecordsFilter?.duration?.split(":")[0])) : this.props?.clearanceRecordsFilter?.duration:null;
                        temp_songs_list[0].sec = this.props?.clearanceRecordsFilter?.duration?(this.props?.clearanceRecordsFilter?.duration?.includes(" ")|| this.props?.clearanceRecordsFilter?.duration?.includes(":")) ? (Number(this.props?.clearanceRecordsFilter?.duration?.split(" ")[1])||Number(this.props?.clearanceRecordsFilter?.duration?.split(":")[1])) : this.props?.clearanceRecordsFilter?.duration:null;
                    }
                    temp_songs_list[0].writer = this.props?.clearanceRecordsFilter?.writer?JSON.parse(JSON.stringify(this.props?.clearanceRecordsFilter?.writer)):[JSON.parse(JSON.stringify(clearanceWritersList))];
                    this.setState((prevState) => ({
                        clearanceRecordData: {
                            ...prevState.clearanceRecordData,
                            ["songs_list"]:temp_songs_list
                    }}))
                });
                
            });
        }
        this.getStaticData("lu_ad_card", "adCardOptions");
        if(this.props.mode!=="New" || !this.props?.clearanceRecordsFilter?.selectedUses){
            this.getEntity("useOptions", "MUSIC_USES", "");
        }
        if (this.props?.from) {
            this.getShowLists("");
        }
        if (this.props.mode === "Edit") {
            this.getClearanceData(this.props?.clearenceId);
        } else {
            this.getSongs(" ", 0, "fromDidMount")
        }
        if (this.props.isClearanceRecord) {
            this.setState({ division_id: this.props?.clearance_divisionId })
        }
        const divisionRoles = this.props?.userContext?.active_tenant?.division_role || [];
        const validRoles = ['Music Supervisor', 'Music Editor/Supervisor'];
        const isMusicSupervisorEmail = divisionRoles.every(role => validRoles.includes(role?.role_name));
        this.setState({ isMusicSupervisorEmail });
        // this.getStaticData("lu_performer","performer");
        
    }
    
    getEntity = (entity, entitytype, searchString, mode=null) => {
        if (entitytype === 'MUSIC_USES') {
            this.setState({ isFetchingMusicUses: true });
        }
        if (entitytype === 'SEASON') {
            this.setState({ isFetchingSeason: true });
        }
        
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl +
            `/entitySearch?entity=${entitytype}&searchString=${searchString}`, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = [];
                if (entitytype === 'MUSIC_USES') {
                    formattedList = response?.data?.map(item => ({ value: item.music_uses_id, label: item.abbreviation , is_active: item.is_active}));
                    if(mode==="New"){
                        let temp_songs_list=JSON.parse(JSON.stringify(this.state?.clearanceRecordData?.songs_list));
                        temp_songs_list[0]["music_uses_id"]=this.props.clearanceRecordsFilter?.selectedUses;
                        this.setState((prevState) => ({
                            clearanceRecordData: {
                                ...prevState.clearanceRecordData,
                                ["songs_list"]: temp_songs_list
                            }
                        }));
                    }
                }
                if (entitytype === 'SEASON') {
                    formattedList = response?.data?.map(item => ({ value: item.season_id, label: item.season_name }));
                }
                if (entitytype === 'PERFORMER') {
                    if(mode==="New"){
                        formattedList = response?.data?.map(item => ({ value: item?.performer_id, text: item?.performer_name, warning_notes: item?.warning_notes }));
                        let temp_songs_list=JSON.parse(JSON.stringify(this.state?.clearanceRecordData?.songs_list));
                        let selected_performer = formattedList?.find(item => item?.value === this.props.clearanceRecordsFilter?.selectedPerformer);
                        temp_songs_list[0]["selected_performer"]=selected_performer;
                        temp_songs_list[0]["performer_id"]=selected_performer.value;
                        temp_songs_list[0]["performer_name"]=selected_performer.text;
                        this.setState((prevState) => ({
                            clearanceRecordData: {
                                ...prevState.clearanceRecordData,
                                ["songs_list"]: temp_songs_list
                            }
                        }));
                    }
                }
                this.setState({ [entity]: formattedList, isFetchingMusicUses: false,isFetchingSeason: false });
            },
                (err) => {
                    if (entitytype === 'MUSIC_USES') {
                        this.setState({ isFetchingMusicUses: false });
                    }
                    if (entitytype === 'SEASON') {
                        this.setState({ isFetchingSeason: false });
                    }
                    
                    console.log("Error in fetching entities:", err)
                })
    }
    handleCloseEditSongModal = () => {
                this.setState({ isEditingPerformer: false,newPerformerData: null });
    };  

    getPerformer = (song_id, index, selectedPerformerId = null, selectedPerformer = null, origin = null) => {
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/songDetails?song_id=${song_id}`, this.props.userContext?.active_tenant?.tenant_id)  
    .then(response => {
         const songDetails = response?.data?.[0] || {};
         let songDoNotUse = songDetails?.song_is_do_not_use

         //this.handleSongDataChange("song", response?.data?.[0]?.is_PD)
         let tempClearanceRecordData = this.state.clearanceRecordData;
         tempClearanceRecordData.songs_list[index]["is_PD"] = songDetails?.is_PD;
         if (!selectedPerformerId) {
            this.applySongCheckboxFields(tempClearanceRecordData.songs_list[index], songDetails);
         }
         let restrictedSong = songDetails?.is_all_promo_use_restricted    
         let formattedList = Array.isArray(songDetails?.performers_list)? songDetails?.performers_list.map(item => ({value: item.performer_id, text: item.performer_name})) : [];
        if (restrictedSong == 1) {
                    this.setState({ selectedRestrictedSong: true, index: index })
                }
        if (formattedList.length > 0 && !selectedPerformerId) { 
            this.handleSongDataChange("performer", formattedList[formattedList.length - 1], index, 'autoFromSongLoad')
        } else if (!selectedPerformerId) { 
            this.handleSongDataChange("performer", null, index, 'autoFromSongLoad')
     }                  
      let performerList = [...this.state.performerList]
      performerList[index] = formattedList;
      let songUseArr = [...this.state.songUse]
      songUseArr[index] = songDoNotUse 
      if (!selectedPerformerId) {
        this.setState({
          performerList,
          songUse: songUseArr,
          isEditingPerformer: false,
          editingPerformerSongIndex: null,
          clearanceRecordData: tempClearanceRecordData
        });
        return;
      }
      const isPerformerInList = formattedList.some(
        performer => performer.value === selectedPerformerId
      );
      const performerName = selectedPerformer?.text || tempClearanceRecordData.songs_list[index]?.performer_name;
      const performerData = { performer: { value: selectedPerformerId, text: performerName } };

      this.setState({
        performerList,
        songUse: songUseArr,
        clearanceRecordData: tempClearanceRecordData,
      }, () => {
        if (isPerformerInList) {
          if (origin !== 'autoFromSongLoad' && selectedPerformerId) {
            this.showPerformerWarningOnClearanceRecord(
              selectedPerformerId,
              performerName,
              selectedPerformer?.warning_notes
            );
          }
          return;
        }

        this.maybeShowPerformerWarningThenOpenEditSong(
          index,
          performerData,
          selectedPerformerId,
          performerName,
          selectedPerformer?.warning_notes
        );
      });      
    })
    .catch(err => {
      console.error("Error fetching performer details:", err);
      this.setState({
        isEditingPerformer: false,
        editingPerformerSongIndex: null
      });
    });
};

    applySongCheckboxFields = (songItem, songDetails) => {
        if (!songItem || !songDetails) return;
        songItem.is_library = songDetails?.is_library === 1 ? 1 : 0;
        songItem.is_do_not_use = songDetails?.song_is_do_not_use === 1 ? 1 : 0;
        songItem.is_studio_owned = songDetails?.is_studio_owned === 1 ? 1 : 0;
        songItem.is_contains_sample = songDetails?.is_contains_sample === 1 ? 1 : 0;
        songItem.is_all_promo_use_restricted = songDetails?.is_all_promo_use_restricted === 1 ? 1 : 0;
        songItem.is_limited_promo_use = songDetails?.is_limited_promo_use === 1 ? 1 : 0;
        songItem.is_arrangement = songDetails?.is_arrangement === 1 ? 1 : 0;
        songItem.is_coa = songDetails?.is_coa === 1 ? 1 : 0;
    }

    formatWriterSelectOptions = (writers_list = []) => {
        return writers_list.map(item => ({
            text: `${item.writer_name ? item?.writer_name : ''}${item.affiliation_name ? ' (' + item.affiliation_name + ')' : ''} ${(item.affiliation_name && item?.share_percentage != null && item?.share_percentage !== 0) ? item?.share_percentage : ''}`,
            temp_text: `${item.writer_name ? item?.writer_name : ''}${item.affiliation_name ? '-' + item.affiliation_name : ''} ${(item.affiliation_name && item?.share_percentage != null && item?.share_percentage !== 0) ? item?.share_percentage : ''}`,
            value: item.writer_id,
            affiliation_id: item?.affiliation_id || null,
            affiliation_name: item?.affiliation_name || null,
        }));
    }

    formatClearanceWritersFromSong = (writers_list = []) => {
        if (writers_list.length === 0) {
            return [JSON.parse(JSON.stringify({ ...clearanceWritersList }))];
        }
        return writers_list.map(item => {
            const writer_name = `${item?.writer_name ? item?.writer_name : ''}${(item?.affiliation_name && item?.affiliation_name != null) ? ' (' + item?.affiliation_name + ')' : ''} ${(item?.affiliation_name && item?.share_percentage != 0 && item?.share_percentage != null) ? item?.share_percentage : ''}`;
            const temp_writer_name = `${item?.writer_name ? item?.writer_name : ''}${(item?.affiliation_name && item?.affiliation_name != null) ? '-' + item?.affiliation_name : ''} ${(item?.affiliation_name && item?.share_percentage != 0 && item?.share_percentage != null) ? item?.share_percentage : ''}`;
            return {
                ...JSON.parse(JSON.stringify({ ...clearanceWritersList })),
                writer_id: item?.writer_id || null,
                writer_name,
                temp_writer_name,
                affiliation_id: item?.affiliation_id || null,
                affiliation_name: item?.affiliation_name || null,
                share_percentage: item?.share_percentage ? item?.share_percentage : 0.00,
                selected_writer: {
                    value: item?.writer_id,
                    text: writer_name
                }
            };
        });
    }

    getWriters = (song_id, index) => {
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/songDetails?song_id=${song_id}`, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                const songDetails = response?.data?.[0] || {};
                const writers_list = songDetails?.writers_list || [];
                const formattedList = this.formatWriterSelectOptions(writers_list);
                const formattedWriters = this.formatClearanceWritersFromSong(writers_list);
                this.setState(prevState => {
                    const tempClearanceRecordData = { ...prevState.clearanceRecordData };
                    tempClearanceRecordData.songs_list[index].writer = formattedWriters;
                    tempClearanceRecordData.is_songs_updated = 1;
                    const writerList = [...prevState.writerList];
                    writerList[index] = formattedList;
                    const writerOptions = [...prevState.writerOptions];
                    writerOptions[index] = formattedList;
                    return {
                        clearanceRecordData: tempClearanceRecordData,
                        writerList,
                        writerOptions,
                    };
                }, () => {
                    const performersList = songDetails?.performers_list || [];
                    const autoPerformer = performersList[performersList.length - 1];
                    showCombinedSongWarnings(this, {
                        songDetails,
                        tenantId: this.props.userContext?.active_tenant?.tenant_id,
                        filter: {
                            performerId: autoPerformer?.performer_id,
                            writerIds: writers_list
                                .filter((writer) => writer?.writer_id)
                                .map((writer) => String(writer.writer_id)),
                        },
                        onShown: (entries) => registerShownWarningEntities(this, entries),
                    });
                });
            })
            .catch(err => {
                console.error("Error fetching writer details:", err);
            });
    };

    postPerformer(performerName, index, songId = null) {
        let data = JSON.parse(JSON.stringify({ ...this.state?.clearanceRecordData }))
        data.songs_list[index]['performer_id'] = null;
        let ClearancePerformer = { id: null, name: performerName, is_active: 1, table_name: "lu_performer" };
        ClearTrackService.postDataParams(Constants.ClearTrackServiceBaseUrl + `/staticData`,
            ClearancePerformer,
            this.props?.userContext?.active_tenant?.tenant_id)
            .then(
                (response) => {
                    if (response.data.error) {
                        this.props?.notificationComponent(true, 'fail')
                    } else {
                        const newPerformerId = response.data?.[0]?.id;
                        data.songs_list[index]['performer_id'] = newPerformerId || null;
                        data.songs_list[index]['performer_name'] = performerName || null;
                        data.songs_list[index]['selected_performer'] = { value: newPerformerId, text: performerName };
                        data.songs_list[index]['songLoader'] = false;
                        data.is_songs_updated = 1
                        if (songId && newPerformerId) {
                            const performerData = { performer: { value: newPerformerId, text: performerName } };
                            this.setState({
                                clearanceRecordData: data,
                                postInitiated: false,
                                newPerformerData: performerData,
                            }, () => {
                                this.props?.fieldChanged(true, "change");
                                this.maybeShowPerformerWarningThenOpenEditSong(
                                    index,
                                    performerData,
                                    newPerformerId,
                                    performerName,
                                    null
                                );
                            });
                        }else{                        
                        this.setState({ clearanceRecordData: data, postInitiated: false },
                            () => {

                                this.props?.fieldChanged(true, "change")
                            })
                        }
                    }
                },
                (err) => { this.props?.notificationComponent(true, 'fail') }
            )

    }

    getPerformerDetails = (searchString, index) => {
        if (this.state.searchCancelToken != null)
            this.state.searchCancelToken.cancel("Operation canceled due to new request");
        var cancelToken = axios.CancelToken.source();
        this.setState({ searchCancelToken: cancelToken });
        let flags = [...this.state.isPerformerFetching]
        flags[index] = true
        this.setState({ isPerformerFetching: flags })
        ClearTrackService.getDataWithCancel(Constants.ClearTrackServiceBaseUrl +
            `/entitySearch?entity=PERFORMER&searchString=${searchString}`, cancelToken, this.props.userContext?.active_tenant?.tenant_id)
            .then((res) => {
                let formattedList = res?.data?.map(item => ({ value: item?.performer_id, text: item?.performer_name, warning_notes: item?.warning_notes }));
                const matchingPerformers = res?.data?.filter(item => item?.performer_name?.toLowerCase() === searchString.toLowerCase());
                if (this.state.performerList[index]?.length > 0) {
                    this.state.performerList[index].map((item) => {
                        formattedList.unshift(item)
                    })
                }
                let performer = [...this.state.performerOptions]
                performer[index] = formattedList
                let flags = [...this.state.isPerformerFetching]
                flags[index] = false
                this.setState({ isPerformerFetching: flags, performerOptions: performer, matchingPerformers: matchingPerformers})
            })

            .catch((err) => {
                let flags = [...this.state.isPerformerFetching]
                flags[index] = false
                this.setState({ isPerformerFetching: flags })
                console.log("error")
            });
    };
    getInactiveSongs = async (value, index) => {
        let searchObj = {
            'data_type': 'SONGS',
            'search_string': value,
        };
        this.setState({inActiveSongFeatching : true});
    
        try {
            const response = await ClearTrackService.getDataParams(
                Constants.ClearTrackServiceBaseUrl + '/globalSearch',
                searchObj,
                this.props.userContext?.active_tenant?.tenant_id,
                null
            );
    
            let formattedListData = response?.data?.data?.map(item => ({
                value: item?.id?.split('_')[1],
                text: item?.songTitle.trim(),
                isSongActive: item?.is_active,
                songWithWriter : item?.name
            }));
    
            let inActiveSongFormatedList = formattedListData?.filter(item => item.text.toLowerCase() === value.toLowerCase());
            if (inActiveSongFormatedList.length > 0) {
                this.setState({
                    inActiveSongFeatching: false,
                    inActiveSongOptions: inActiveSongFormatedList,
                    openInActiveSongModal: true
                });
            }
            this.setState({ inActiveSongFeatching: false})
            return inActiveSongFormatedList;
        } catch (error) {
            console.error("Error:", error);
            this.setState({ inActiveSongFeatching: false})
        }
    };

    getSongs = (value, index, origin = null) => {
            let searchObj = {
                'data_type': 'SONGS',
                'search_string': value,
            }
            let flags = [...this.state.isSongFetching]
            if(origin==="fromDidMount"){
                flags[index] = false;
            }else{
                flags[index] = true;
            }
            this.setState({ displayAddNewSongOption: false, isSongFetching: flags, searchedSongString: value, searchedSongIndex: index });
            if (this.state.searchCancelToken != null){
                this.state.searchCancelToken.cancel("Operation canceled due to new request");
            }
            var cancelToken = axios.CancelToken.source();
            this.setState({searchCancelToken: cancelToken },()=>{
                ClearTrackService.getDataParamsWithCancel(Constants.ClearTrackServiceBaseUrl + '/globalSearch', searchObj, this.props.userContext?.active_tenant?.tenant_id, null, cancelToken)
                .then(response => {
                    let exsitingSongs = this.state.mainTitleClearanceData?.songs_list?.map(item => item?.song_id)
                    let formattedList = response?.data?.data?.map(item => ({ value: item?.id?.split('_')[1], text: item?.name, isSongActive : item?.is_active }))
                    this.setState({
                        songOptions: formattedList?.filter(item => !exsitingSongs?.includes(item?.value) && item.isSongActive === 1),
                        displayAddNewSongOption:true
                    }, () => {
                        flags[index] = false
                        this.setState({ selectSong: this.state?.newSongId?.toString()?.toLowerCase(), isSongFetching: flags });
                        if (origin === "fromNewSong") {
                            this.handleSongDataChange("song",
                                this.state.songOptions.find(songid => {
                                    return songid.value == this.state.newSongId
                                })
                                , index)
                        }
    
                    })
                },
                    (err) => {
                        this.setState({ displayAddNewSongOption:false })
                    }
                )
            });
            // if (value) {
            
        // }
    }

    //closing new song add popup
    newSongPopup() {
        this.setState({ newSongPopup: false, proposedNewSong : null });
    }
    newSongId(songId, songTitle = null, index = 0) {
        this.setState({ newSongId: songId, searchSelect: false,loadingSongs:true }, () => {
            this.setState({ newSongPopup: false });
            this.getSongs(songTitle, index, "fromNewSong");
        });
    }

    valueSelected(index) {
        this.getSongs(this.state?.newSongId, index);
    }

    getShowLists = (value) => {
        if (this.state.searchCancelToken != null)
            this.state.searchCancelToken.cancel("Operation canceled due to new request");
        var cancelToken = axios.CancelToken.source();
        this.setState({ searchCancelToken: cancelToken });
        // if (value) {
        this.setState({ isFetchingShow: true })
        ClearTrackService.getDataWithCancel(Constants.ClearTrackServiceBaseUrl + `/entitySearch?entity=SHOW&searchString=${value}`, cancelToken, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = response?.data?.map(item => ({ value: item.show_id, text: item.show_name, division_id: item.division_id }));
                this.setState({ showsOptions: formattedList, isFetchingShow: false })
            },
                (err) => {
                    console.log("Error in fetching entities:", err)
                })
        // }

    }
    getWriterList = (value,childIndex,parentIndex) => {
        let clearanceRecordData = JSON.parse(JSON.stringify(this.state.clearanceRecordData));
        
        if (this.state.searchCancelToken != null)
            this.state.searchCancelToken.cancel("Operation canceled due to new request");
        var cancelToken = axios.CancelToken.source();
        this.setState({ searchCancelToken: cancelToken });
        // if (value) {
        // clearanceRecordData.songs_list[parentIndex].writer[childIndex].writer_name = value;
        // clearanceRecordData.songs_list[parentIndex].writer[childIndex].writer_id = value;
        this.setState({ isFetchingWriter: true})
        ClearTrackService.getDataWithCancel(Constants.ClearTrackServiceBaseUrl + `/entitySearch?entity=WRITER&searchString=${value}`, cancelToken, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = response?.data?.filter(writer => writer?.is_active === 1)?.map(item => ({ 
                    text: `${item.writer_name ? item?.writer_name : ''}${item.affiliation_name ? ' (' + item.affiliation_name + ')' : ''} ${(item.affiliation_name && item?.share != null && item?.share !== 0) ? item?.share : ''}`,
                            temp_text: `${item.writer_name ? item?.writer_name : ''}${item.affiliation_name ? '-' + item.affiliation_name : ''} ${(item.affiliation_name && item?.share != null && item?.share !== 0) ? item?.share : ''}`,
                            value: item.writer_id,
                            affiliation_id: item?.affiliation_id || null,
                            affiliation_name: item?.affiliation_name || null,
                            warning_notes: item?.warning_notes || null,}));
                if (this.state.writerList[parentIndex]?.length > 0) {
                    this.state.writerList[parentIndex].map((item) => {
                        formattedList.unshift(item)
                    })
                }
                let writerOptions = [...this.state.writerOptions];
                writerOptions[parentIndex] = formattedList;
                this.setState({ writerOptions, isFetchingWriter: false })
            },

                (err) => {
                    console.log("Error in fetching entities:", err)
                })
        // }

    }

    getClearanceData = (clearance_id) => {
        this.setState({ isDataLoading: true });
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/clearance?clearance_id=${clearance_id}`, this.props.userContext?.active_tenant?.tenant_id, this.props?.clearance_divisionId)
            .then(response => {
                let clearanceList = response?.data[0]
                if(clearanceList?.songs_list?.length > 0){
                    clearanceList?.songs_list?.map((song,index)=>{
                        if(song?.writer?.length == 0){
                            song?.writer.push(JSON.parse(JSON.stringify({ ...clearanceWritersList })));
                        }else{
                            song?.writer?.map((item) => {
                            item['temp_writer_name'] = `${item?.writer_name ? item?.writer_name : ''}${(item?.affiliation_name && item?.affiliation_name != null) ? '-' + item?.affiliation_name : ''} ${(item?.affiliation_name && item?.share_percentage != 0 && item?.share_percentage != null) ? item?.share_percentage : ''}`;

                            item.writer_name = `${item?.writer_name ? item?.writer_name : ''}${(item?.affiliation_name && item?.affiliation_name != null) ? ' (' + item?.affiliation_name + ')' : ''} ${(item?.affiliation_name && item?.share_percentage != 0 && item?.share_percentage != null) ? item?.share_percentage : ''}`;
                            item.song_writer_is_delete = item?.song_writer_is_delete ? 1 : 0;
                            item.share_percentage = item?.share_percentage ? item?.share_percentage : 0.00;
                            item.selected_writer = {
                                value: item?.writer_id,
                                text: item?.writer_name
                            }}
                        ) 
                        }
                    })
                }
                let sondDonotArr = clearanceList?.songs_list?.map(item => item?.is_do_not_use)
                let songListData = clearanceList?.songs_list
                let writerList = clearanceList?.songs_list?.map(song =>
                    song?.writer?.filter(writer => writer?.writer_id)?.map(item => ({
                        value: item?.writer_id,
                        text: item?.writer_name,
                        temp_text: item?.temp_writer_name,
                        affiliation_id: item?.affiliation_id || null,
                        affiliation_name: item?.affiliation_name || null,
                    })) || []
                ) || []
                this.setState({
                    songListData: songListData,
                    clearanceRecordData: this.formatClearanceDetails(JSON.parse(JSON.stringify(clearanceList))),
                    isDataLoading: false,
                    division_id: response?.data[0]?.division_id,
                    songUse: sondDonotArr,
                    writerList,
                }, () => {

                })
                if (clearanceList?.show_id) {
                    this.getSeasons(clearanceList?.show_id)
                }
            },
                (err) => {
                    console.log("Error in fetching entities:", err)
                    this.setState({ isDataLoading: false });
                })
    }

    getSeasons = (showId,mode=null) => {
        this.setState({ isFetchingSeason: true })
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/seasonsBasedOnShows?show_id=${showId}`, this.props.userContext?.active_tenant?.tenant_id, this.state.division_id)
            .then(response => {
                let formattedList = response.data[0]?.seasons?.map(item => ({ value: item.season_id, label: item.season_name, show_season_id: item.show_season_id }));
                this.setState({ seasonOptions: formattedList, isFetchingSeason: false },()=>{
                    if(mode==="New"){
                        let selectedShowSeasontemp = this.state.seasonOptions?.find(item => item?.value == this.state.clearanceRecordsFilter?.selectedSeason)?.show_season_id;
                        this.setState((prevState) => ({
                            clearanceRecordData: {
                                ...prevState.clearanceRecordData,
                                ["show_season_id"]: selectedShowSeasontemp,
                            }
                        }));
                        this.getShowBasedEpisodes(selectedShowSeasontemp,mode);
                    }
                });

            },
                (err) => {
                    console.log("Error in fetching Tenant Details:", err)
                })
    }

    getShowBasedEpisodes = (showSeasonId,mode=null) => {
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/showSeasonEpisodes?show_season_id=${showSeasonId}`, this.props.userContext?.active_tenant?.tenant_id, this.state.division_id)
            .then(response => {
                let formattedList = response.data?.map(item => ({ value: item.show_season_episode_id, label: `${item.episode_number ? item.episode_number : ''}${item.episode_title ? '-' + item.episode_title : ''}` }));
                this.setState({ episodeOptions: formattedList, loadingEpisodes: false },()=>{
                    if(mode==="New"){
                        this.setState((prevState) => ({
                            clearanceRecordData: {
                                ...prevState.clearanceRecordData,
                                ["episode_title"]: this.state.episodeOptions?.find(item => item?.value === this.props.clearanceRecordsFilter?.selectedEpisode)?.label
                            }
                        }));
                    }
                });
            },
                (err) => {
                    console.log("Error in fetching Details:", err)
                })
    }

    getStaticData = (tableName, fieldName, mode=null) => {
        ClearTrackService.getData(Constants.ClearTrackServiceBaseUrl + `/staticData?staticTable=${tableName}`, null)
            .then(response => {
                let formattedList = response.data?.map(item => ({ value: item.id, label: item.name }));
                this.setState({ [fieldName]: formattedList, });
            },
                (err) => {
                    console.log("Error in fetching Details:", err)
                })
    }
    
    postSendDataEmail = (payload) => {
        const tenantId = this.props?.userContext?.active_tenant?.tenant_id;
        this.setState({ isSendEmail: true });
        ClearTrackService.postDataParams(`${Constants.ClearTrackServiceBaseUrl}/sendEmail`, payload, tenantId)
            .then(() => this.setState({ isSendEmail: false }))
            .catch(() => this.setState({ isSendEmail: false }));
    };

    isTrackableWriter = (writer, writerIdKey) => {
        return !!(writer?.writer_id || writer?.[writerIdKey]);
    };

    getActiveWriters = (writers = [], writerIdKey) => {
        return (writers || []).filter(
            writer => writer?.song_writer_is_delete !== 1 && this.isTrackableWriter(writer, writerIdKey)
        );
    };

    findMatchingWriter = (writer, writers = [], writerIdKey) => {
        if (writer?.[writerIdKey]) {
            return writers.find(item => item?.[writerIdKey] === writer?.[writerIdKey]);
        }
        if (writer?.writer_id) {
            return writers.find(item => item?.writer_id === writer?.writer_id && !item?.[writerIdKey]);
        }
        return null;
    };

    trackWriterChangesForSong = (originalWriters = [], currentWriters = []) => {
        const writerIdKey = 'clearance_song_writer_id';
        const changes = [];
        const activeOriginalWriters = this.getActiveWriters(originalWriters, writerIdKey);
        const activeCurrentWriters = this.getActiveWriters(currentWriters, writerIdKey);

        activeCurrentWriters.forEach(newWriter => {
            const existingWriter = this.findMatchingWriter(newWriter, activeOriginalWriters, writerIdKey);

            if (!existingWriter) {
                if (newWriter?.writer_id && newWriter?.writer_name) {
                    changes.push({
                        type: "added",
                        writer: newWriter.writer_name
                    });
                }
            } else {
                const hasChanges = (
                    existingWriter?.writer_name !== newWriter?.writer_name ||
                    existingWriter?.share_percentage !== newWriter?.share_percentage ||
                    existingWriter?.affiliation_name !== newWriter?.affiliation_name
                );

                if (hasChanges) {
                    changes.push({
                        type: "changed",
                        original: existingWriter?.writer_name,
                        updated: newWriter?.writer_name
                    });
                }
            }
        });

        activeOriginalWriters.forEach(existingWriter => {
            const newWriter = this.findMatchingWriter(existingWriter, activeCurrentWriters, writerIdKey);
            if (!newWriter && existingWriter?.writer_name) {
                changes.push({
                    type: "removed",
                    writer: existingWriter.writer_name
                });
            }
        });

        (currentWriters || []).forEach(writer => {
            if (writer?.song_writer_is_delete !== 1 || !this.isTrackableWriter(writer, writerIdKey)) return;
            if (!writer?.writer_name) return;

            const wasTracked = changes.some(
                change => change.type === "removed" && change.writer === writer.writer_name
            );
            if (!wasTracked) {
                changes.push({
                    type: "removed",
                    writer: writer.writer_name
                });
            }
        });

        return changes;
    };

    sendEditSongEmailNotifications = (postJson) => {
        if (!this.state.isMusicSupervisorEmail) return;

        (postJson?.songs_list || []).forEach((song) => {
            if (song?.is_delete === 1 || !song?.song_id) return;

            const originalSong = (this.state.songListData || []).find(
                item => item?.clearance_song_id === song?.clearance_song_id
            ) || (this.state.songListData || []).find(
                item => item?.song_id === song?.song_id
            );

            if (!originalSong) return;

            const writerChanges = this.trackWriterChangesForSong(originalSong?.writer, song?.writer);

            if (writerChanges.length > 0) {
                const payload = {
                    letter_type: "editSongDetailNotification",
                    song_title: song?.song_title,
                    licensor_changes: [],
                    performer_licensor_changes: [],
                    writer_changes: writerChanges,
                    performer_changes: [],
                    cue_sheet_publisher_changes: [],
                    pd_composer_changes: []
                };
                this.postSendDataEmail(payload);
            }
        });
    };

    handleSubmit = () => {    
        return new Promise((resolve, reject) => {            
            this.setState({ postInitiated: true })
            let data = JSON.parse(JSON.stringify(this.state.clearanceRecordData));
            if (this.props?.isClearanceRecord) {
                data.show_id = this.props.showId
                data.show_season_id = this.props.show_season_id
                data.season_id = this.props.seasonId
                data.show_season_episode_id = +this.props.episodeId
                data.show_name = this.props.show_name
                data.episode_title = this.props.episode_name
            } else {
                data.show_season_id = this.state.clearanceRecordData.show_season_id || this.props.show_season_id
                data.clearance_rep_id = this.props?.clearance_rep_id || null
            }
            if (this.validateFlagError(data)) {
                this.postClearanceData(data).then(() => resolve()).catch(reject);
            }
        });
    }
    validateFlagError = (data) => {
        let canSubmit = false;
        canSubmit = (
            data?.show_id && data?.season_id && data?.show_season_episode_id &&
            (data?.songs_list?.length > 0 && this.validateSongs(data?.songs_list)))
        return canSubmit;
    }

    validateSongs(songList) {
        let canSubmit = true;
        let i = 0;
        for (i; i < songList?.length; i++) {
            let obj = songList[i];
            if ((!obj.song_id || !obj.song_title ||
                !obj.music_uses_id) || (this.state.useOptions?.find(item => item?.value === obj.music_uses_id)?.label !== 'Custom Use' ?
                    (obj?.sec ? !(obj?.sec < 60 && validateNumbersOnly(obj?.sec)) : false) || (obj?.min ? !(validateNumbersOnly(obj?.min)) : false) : false)) {
                canSubmit = false;
                break;
            }
        }
        return canSubmit;
    }

    postClearanceData = (postJson) => {
        return new Promise((resolve, reject) => {
            this.setState({ isPosting: true, postInitiated: true })
            if (this.props?.isClearanceRecord) {
                postJson.show_id = this.props.showId
                postJson.show_season_id = this.props.show_season_id
                postJson.season_id = this.props.seasonId
                postJson.show_season_episode_id = this.props.episodeId
                postJson.show_name = this.props.show_name
                postJson.episode_title = this.props.episode_name
            }
            if (this.state.deletedSongs.length > 0) {
                postJson.songs_list = [...postJson.songs_list, ...this.state.deletedSongs]
            }
            for (let i = 0; i < postJson.songs_list?.length; i++) {
                postJson.songs_list[i].duration = `${postJson?.songs_list[i]?.min ? postJson.songs_list[i].min : 0}:${postJson.songs_list[i]?.sec ? postJson.songs_list[i]?.sec : 0}`
                delete postJson.songs_list[i].min
                delete postJson.songs_list[i].sec
                if(postJson.songs_list[i]?.is_CR_PD === null || postJson.songs_list[i]?.is_CR_PD === undefined){
                    if(postJson.songs_list[i]?.is_PD===0 || postJson.songs_list[i]?.is_PD === null || postJson.songs_list[i]?.is_PD=== undefined){
                        postJson.songs_list[i].is_CR_PD = 0;
                    }else{
                        postJson.songs_list[i].is_CR_PD = 1;
                    }
                }
                delete postJson.songs_list[i].is_PD
                if (this.state.deletedWriters.length > 0) {
                    this.state.deletedWriters.map((deletedWriter) => {
                        if(deletedWriter.clearance_song_id === postJson.songs_list[i].clearance_song_id){
                        delete deletedWriter.clearance_song_id;
                        postJson?.songs_list[i]?.writer?.push(deletedWriter);
                    }})
                }
                if(postJson.songs_list[i]?.writer?.length > 0){
                    const filteredWriters = postJson.songs_list[i]?.writer?.filter(
                        w => w.writer_id !== null || w.clearance_song_writer_id !== null
                    );
                    postJson.songs_list[i].writer= filteredWriters;
                }
            }
            let extensionUrl = '/clearance'
            ClearTrackService.postDataParams(Constants.ClearTrackServiceBaseUrl + extensionUrl, postJson, this.props.userContext?.active_tenant?.tenant_id, this.state.division_id)
                .then((response) => {
                    if (!response.data.error) {
                        this.setState({ isPosting: false, postInitiated: false })
                        this.props?.fieldChanged(false, "error");
                        this.props?.notificationComponent(true, "success")
                        this.sendEditSongEmailNotifications(postJson);
                        if (this.props?.handleSubmit) {
                            this.props?.handleSubmit(postJson.show_season_id, postJson.show_season_episode_id, response.data[0]?.clearance_id)
                        }
                        // if (this.props?.updateClearanceDetails) {
                        //     let updatedDetails = [];
                        //     updatedDetails.push(postJson)
                        //     this.props?.updateClearanceDetails(updatedDetails);
                        // }
                        //this.props?.toggleRefreshPage('EpisodeClearance');
                        setTimeout(() => {
                            if (this.props?.mode === 'New' && this.props?.toggleRefreshClearanceList) {
                                this.props?.toggleRefreshClearanceList();
                            }
                            else {
                                if (this.props?.toggleRefreshPage) {
                                    this.props?.toggleRefreshPage('EpisodeClearance');
                                }
                            }
                        }, 2000)

                        resolve(response);
                    }
                    else {
                        this.setState({ isPosting: false, postInitiated: false })
                        this.props?.notificationComponent(true, "fail")
                        reject(new Error('Server responded with an error'));
                    }
                })
                .catch((err) => {
                    this.setState({ isPosting: false, postInitiated: false });
                    this.props?.notificationComponent(true, "fail");
                    console.log("Post agency details error: " + err);
                    reject(err); // Reject the promise with the caught error
                });
        });
    }
    
    handleChange = (field, value, index=null) => {
        console.log("field,value,index",field,value,index);
        console.log("typeof value",typeof value);
        if(field === "writer"){
            this.setState((prevState) => ({
                clearanceRecordData: {
                    ...prevState.clearanceRecordData,
                    [field]: value,
                },
                postInitiated: false
            }));
        }else if(field==="is_all_promo_use_restricted" || field === "is_limited_promo_use" || field==="is_library" || field === "is_coa" || field==="is_contains_sample" || field === "is_studio_owned" || field === "is_arrangement" || field === "is_CR_PD" || field === "is_do_not_use"){ 
            let selectedSong =  this.state.clearanceRecordData?.songs_list[index]
            selectedSong[field] = value ? 1 : 0;
            if(field==="is_all_promo_use_restricted"){
                selectedSong["is_limited_promo_use"] = 0;
            }
            let tempClearanceRecordDataSongList = JSON.parse(JSON.stringify(this.state.clearanceRecordData?.songs_list))
            tempClearanceRecordDataSongList[index]=selectedSong;
            this.setState(prevState => ({
                clearanceRecordData: {
                    ...prevState.clearanceRecordData,
                    "songs_list": tempClearanceRecordDataSongList,
                    "is_songs_updated": 1
                }
            }));
        }else{
            this.setState((prevState) => ({
                clearanceRecordData: {
                    ...prevState.clearanceRecordData,
                    [field]: value,
                },
                postInitiated: false
            }));
        }
        this.props?.fieldChanged(true, "change")
    }


    onCheckboxChange = (value, field) => {
        this.setState((prevState) => ({
            clearanceRecordData: {
                ...prevState.clearanceRecordData,
                [field]: value ? 1 : 0
            },
            postInitiated: false,
        }));
        this.props?.fieldChanged(true, "change");
    }

    removeField(field,index,parentIndex=null){
        let data = { ...this.state.clearanceRecordData }        
        let deleteExistingItem = null;
        switch  (field){
            case "song":
            let existingSongList = [...this.state.songListData]
            let deletedItem = data?.songs_list[index]
            if (deletedItem?.clearance_song_id) {
                deletedItem.is_delete = 1
                let deletedSongs = [...this.state.deletedSongs, deletedItem]
                this.setState({ deletedSongs: deletedSongs })
                data.is_songs_updated = 1
            }
            data.songs_list.splice(index, 1)
            deleteExistingItem = existingSongList.filter(item => item.song_id !== deletedItem.song_id)
            this.setState({ clearanceRecordData: data, postInitiated: false, songListData: deleteExistingItem })
            this.props?.fieldChanged(true, "change")
        break;
        case "writer":
            let writerToDelete = data?.songs_list?.[parentIndex]?.writer?.[index];
            if (writerToDelete?.clearance_song_writer_id) {
                writerToDelete.song_writer_is_delete = 1;
                writerToDelete.clearance_song_id = data?.songs_list?.[parentIndex]?.clearance_song_id;
                let deletedWriters = [...this.state.deletedWriters, writerToDelete]
                this.setState({ deletedWriters: deletedWriters })
            }
            data.is_songs_updated = 1
        data.songs_list[parentIndex].writer.splice(index, 1);
            if(data.songs_list[parentIndex].writer.length === 0){
                data.songs_list[parentIndex].writer.push(JSON.parse(JSON.stringify({ ...clearanceWritersList })));
            }
        this.setState({ clearanceRecordData: data, postInitiated: false })
        this.props?.fieldChanged(true, "change")
        break;
        }
    }

    addField(fieldName, index=null, parentIndex=null) {
        switch (fieldName) {
            case "song":
                let data = null;
                data = { ...this.state.clearanceRecordData };
                data.songs_list.push(JSON.parse(JSON.stringify({ ...mockSong })))
                this.setState({ clearanceRecordData: data, postInitiated: false, songOptions:[] })
                this.props?.fieldChanged(true, "change")
                break;
            case "writer":
                let clearanceRecordData = { ...this.state.clearanceRecordData }
                if (clearanceRecordData?.songs_list?.[parentIndex]?.writer?.[index]?.writer_name) {
                    let writersArray = JSON.parse(JSON.stringify({ ...clearanceWritersList }));
                    let writer = JSON.parse(JSON.stringify(clearanceRecordData?.songs_list?.[parentIndex]?.writer));
                    writer.push(writersArray);
                    // console.log("writer in clearanceRecordData.songs_list[parentIndex]",clearanceRecordData.songs_list[parentIndex])
                    clearanceRecordData.songs_list[parentIndex].writer = writer;
                    let writerOptions = [...this.state.writerOptions];
                    writerOptions[parentIndex] = this.state.writerList[parentIndex] || [];
                    this.setState({ clearanceRecordData, postInitiated: false, writerOptions });
                }
                break;
            default:
                break;
        }
    }    
    handleResetNotify = () => {
        this.setState({ showDuplicateNotification: false});
    };

    handleSongDataChange = (fieldName, value, index, origin=null,parentIndex=null) => {
        let data =  { ...this.state.clearanceRecordData };
        let full_performer = null;                
        if (fieldName === "song") {            
            this.setState({ searchSelect: true })
            if (value?.optionType == 'new') {
                this.getInactiveSongs(value.value, index)
                .then(result => { 
                    if(!this.state.openInActiveSongModal){
                        this.setState({ newSongPopup: true, proposedNewSong: value, newSongRowIndex: index })
                    }
                    if(result.length > 0){
                        const inActiveSong = result.filter(el=> el.isSongActive === 0)
                            .map(item => item.songWithWriter)
                            .join(', ');
                        const activeSong = result.find(el => el.isSongActive)?.text;   
                        this.setState({inActiveSong :inActiveSong,activeSong: activeSong, proposedNewSong: value, newSongRowIndex: index })
                    }
                })
                .catch(error => {
                    console.error("Error:", error);
                });
                // this.postPerformer(value?.value, index)
            } else {
                if (value) {
                     data.songs_list[index][fieldName + '_id'] = value?.value || null;
                    data.songs_list[index][fieldName + '_title'] = value?.text || null;
                    data.songs_list[index]["selected_song"] = value || null;
                    data.is_songs_updated = 1
                    data.songs_list[index]['songLoader'] = true
                    this.getPerformer(value?.value, index);
                    this.getWriters(value?.value, index);
                    data.songs_list[index]["performer_id"] = null;
                    data.songs_list[index]["performer_name"] = null;
                    data.songs_list[index]["selected_performer"] = null; 
                } else {
                    data.songs_list[index][fieldName + '_id'] = null;
                    data.songs_list[index][fieldName + '_title'] = null;
                    data.songs_list[index]['selected_song'] = null;
                    data.songs_list[index]["performer_id"] = null;
                    data.songs_list[index]["performer_name"] = null;
                    data.songs_list[index]["selected_performer"] = null;
                    data.songs_list[index]['songLoader'] = false;
                    data.songs_list[index].writer = [JSON.parse(JSON.stringify({ ...clearanceWritersList }))];
                    ['is_library', 'is_do_not_use', 'is_studio_owned', 'is_contains_sample', 'is_all_promo_use_restricted', 'is_limited_promo_use', 'is_arrangement', 'is_coa'].forEach(field => {
                        data.songs_list[index][field] = 0;
                    });
                    let writerList = [...this.state.writerList];
                    writerList[index] = [];
                    let writerOptions = [...this.state.writerOptions];
                    writerOptions[index] = [];
                    this.setState({ performerOptions: [], writerList, writerOptions })                    
                }
                this.setState({ proposedNewSong: null, newSongRowIndex: null });
            }
            this.setState({loadingSongs:false})
        }
        else if (fieldName === "performer" && value?.optionType == 'new') {
            const hasDuplicates = this.state.matchingPerformers?.some(item => item?.performer_name?.toLowerCase() === value?.value?.toLowerCase());
            if(hasDuplicates){
                this.setState({showDuplicateNotification: true, duplicatePerformerName: value?.value, performerOptions: []})
                return;
            }
                const songId = data.songs_list[index]?.song_id;
                this.postPerformer(value?.value, index, songId);
        }
        else if (fieldName === "performer") {
           data.songs_list[index][fieldName + '_id'] = value?.value || null;
           data.songs_list[index][fieldName + '_name'] = value?.text || null;
           data.songs_list[index]['selected_performer'] = value;
           data.songs_list[index]['songLoader'] = false;
           data.is_songs_updated = 1
           const selectedPerformerId = value?.value;
           const songId = data.songs_list[index]?.song_id;
           this.setState({ clearanceRecordData: data, loadingSongs: false, writerMode: null }, () => {
               if (songId && selectedPerformerId) {
                   this.getPerformer(songId, index, selectedPerformerId, value, origin);
               }
           });
           this.props?.fieldChanged(true, "change");
           return;
    }
                                
        else if (fieldName === "min" || fieldName === "sec") {
            data.songs_list[index][fieldName] = value
            data.is_songs_updated = 1
        }
        else if (fieldName === "scene" ) {
            data.songs_list[index][fieldName] = value
            data.is_songs_updated = 1
        }
        else if (fieldName === "music_uses_id") {
            data.songs_list[index][fieldName] = value
            data.is_songs_updated = 1
            data.songs_list[index]['custom_use'] = this.state.useOptions?.find(item => item?.value === value)?.label !== 'Custom Use' ? null : data.songs_list[index]['custom_use'] || null
        } else if (fieldName === 'custom_use') {
            data.songs_list[index][fieldName] = value;
            data.songs_list[index]["min"] = 0;
            data.songs_list[index]["sec"] = 0;
            data.songs_list[index]['customPopover'] = null
        }else if (fieldName === 'writer') {
            let songs_list = JSON.parse(JSON.stringify(this.state.clearanceRecordData.songs_list));
            songs_list[parentIndex].writer[index]['writer_id'] = value?.value || null;
            songs_list[parentIndex].writer[index]['writer_name'] = value?.text || null;
            songs_list[parentIndex].writer[index]['selected_writer'] = value;
            songs_list[parentIndex].writer[index]['affiliation_id'] = value?.affiliation_id || null;
            songs_list[parentIndex].writer[index]['affiliation_name'] = value?.affiliation_name || null;
            songs_list[parentIndex].writer[index]['temp_writer_name'] = value?.temp_text;
            songs_list[parentIndex].writer[index]['share_percentage'] = +(value?.temp_text?.match(/(\d+)$/)?.[1] ?? 0); // this will check last word in temp_text and give share percentafe if the last word is numeric, otherwise it will return 0
            if(!songs_list[parentIndex].writer[index]['clearance_song_writer_id']){
                songs_list[parentIndex].writer[index]['clearance_song_writer_id'] = null;
            }
            songs_list[parentIndex].writer[index]['is_active'] = 1;
            data.songs_list= songs_list
            data.is_songs_updated = 1
            if (value?.value) {
                this.showEntityWarningNotes('writer', value.value, value.text, value.warning_notes);
            }
        }
        else {
            data.songs_list[index][fieldName] = value
            data.is_songs_updated = 1
        }
        this.setState({ clearanceRecordData: data,loadingSongs:false, writerMode: null, }, () => {
            if (fieldName === 'customPopover') {
                this.setState({ customNotes: value ? data.songs_list[index]['custom_use'] : null })
            }
            if (fieldName === 'custom_use') {
                this.setState({ customNotes: null })
            }
        })
        this.props?.fieldChanged(true, "change")
    }

    closPopup = () => {
        this.setState({ selectedRestrictedSong: false })
    }
    onConfirmInActiveSong = ()=>{
        this.setState({ 
            openInActiveSongModal : false, 
            newSongPopup: true ,
            isDuplicateSong: true
         })
    }
    onCloseInActiveSong =()=>{
        this.setState({openInActiveSongModal : false, proposedNewSong : null, isDuplicateSong: true})
    }
    removeSelectedRestrictedSong = () => {
        let clearanceRecordData = this.state.clearanceRecordData
        clearanceRecordData.songs_list[this.state.index].song_id = null
        clearanceRecordData.songs_list[this.state.index].selected_song = {}
        clearanceRecordData.songs_list[this.state.index].selected_performer = null
        this.setState({
            selectedRestrictedSong: false,
            clearanceRecordData: clearanceRecordData
        })
    }

    onDropdownClose = () => {
        this.setState({songOptions: [], searchedSongIndex: null, searchedSongString: null})
    }

    render() {
        let viewApplyHVPermission = this.props?.applyHVPermission?.view == 1 ? true : false;
        let comfirmModalTitle = this.state.selectedRestrictedSong == 1 ? "Restricted Song Selected" : "";
        let message = this.state.selectedRestrictedSong == 1 ? "Restricted Song has been selected" : " ";
        let checkBoxOptionsRight = viewApplyHVPermission ? this.state.checkBoxOptionsRight : this.state.checkBoxOptionsRight.filter((item) => item?.id != "is_apply_dollar_to_HV");
        let editApplyHVPermission = this.props.applyHVPermission?.edit == 1 ? true : false;
        let canEditLicensorInformation = this.props.clearancePermissions?.find((per) => this.state.clearanceRecordPermissionsConfig.find((item) => item.buttonName == "song/performerInfo" && item.permissions.includes(per.permission_name) && item.permissionGroupName.includes(per.permission_group_name)));
        // this.props.mode === "Edit" ? canEditLicensorInformation = this.props?.commonPermissions?.find(item => item.permission_name === "Can edit a Song") : canEditLicensorInformation = this.props?.commonPermissions?.find(item => item.permission_name === "Can create a Clearance Record")
        let loadingFlag = this.state.isFetchingMusicUses || this.state.isDataLoading
        let data = { ...this.state.clearanceRecordData }
        let heading = this.state.clearanceRecordData.show_name ? "For "
            + this.state.clearanceRecordData.show_name + '('
            + this.state.clearanceRecordData?.season_name + ') ' +
            (this.state.clearanceRecordData.show_season_episode_id ? ", Ep. " +
                this.state.clearanceRecordData.show_season_episode_id : " ") +
            (this.state.clearanceRecordData.episode_title ? " - " +
                this.state.clearanceRecordData.episode_title + "." : ".") : " "
        let newMode = "For " + this.props?.show_name + ", Ep. " +
            this.props?.episode_name + " - " + this.props?.season_name + "."
        let songStatus = `There is an ${this.state?.inActiveSong ? "Inactive song "+this.state?.inActiveSong : ""}
            ${this.state?.inActiveSong  && this.state?.activeSong  ? "and also an" : ""}
            ${this.state?.activeSong ? "Active song "+this.state?.activeSong : ""}.
            Still do you want to create new song?`
        const divisionRoles = this.props?.userContext?.active_tenant?.division_role || [];
        const validRoles = ['Music Supervisor', 'Music Editor/Supervisor'];
        const isMusicSupervisor = divisionRoles.every(role => validRoles.includes(role?.role_name));
        return (
            <>
                {loadingFlag ? (
                    <div style={{ textAlign: "center" }}>
                        <CircularProgress size={24} />
                    </div>
                ) : (
                        // <div disabled={!canEditLicensorInformation}>
                        <div>
                            <MDBContainer fluid className="ModalContainer ClearanceRecordContainer">
                                {this.state.selectedRestrictedSong &&
                                    <MessageModal
                                        open={this.state.selectedRestrictedSong || false}
                                        title={comfirmModalTitle}
                                        message={message}
                                        hideCancel={false}
                                        primaryButtonText={"OK"}
                                        secondaryButtonText={"Cancel"}
                                        onConfirm={() => this.closPopup()}
                                        handleClose={(e) => this.removeSelectedRestrictedSong()} />
                                }
                                
                                <div className="between">
                                    <div>
                                        {
                                            this.props?.from ? null :
                                                <BasicLabel
                                                    text={!this.props.isClearanceRecord ? heading : newMode}
                                                />
                                        }
                                    </div>
                                    <div>
                                        {this.props.mode === "Edit" && this.state.clearanceRecordData.clearance_id != null ? <BasicLabel text={"Clearance Id - " + this.state.clearanceRecordData.clearance_id} /> : null}
                                    </div>
                                </div>
                                {!this.props?.from ?
                                    null
                                    :
                                    <div>
                                        <MDBRow>
                                            <MDBCol md={4}>
                                                <SearchSelectField
                                                    id={"clearence-show"}
                                                    label={"Show"}
                                                    placeholder={'- Search -'}
                                                    options={this.state.showsOptions || []}
                                                    isMandatory={true}
                                                    showMandatory={this.state.postInitiated}
                                                    mandatoryWarning={messages.mandatoryWarning}
                                                    searchSelect={true}
                                                    loading={this.state.isFetchingShow}
                                                    detail_selected={this.state.clearanceRecordData?.selected_show?this.state.clearanceRecordData?.selected_show:this.state?.clearanceRecordsFilter?.selectedShow?this.state?.clearanceRecordsFilter?.selectedShow:null}
                                                    width={'100%'}
                                                    valueSelected={(e, newValue) => {
                                                        this.handleChange('show_id', newValue ? newValue?.value:this.state?.clearanceRecordsFilter?.selectedShow?this.state?.clearanceRecordsFilter?.selectedShow?.value : null)
                                                        this.handleChange('show_name', newValue ? newValue?.text:this.state?.clearanceRecordsFilter?.selectedShow?this.state?.clearanceRecordsFilter?.selectedShow?.text : null)
                                                        this.handleChange('selected_show', newValue ? newValue:this.state?.clearanceRecordsFilter?.selectedShow?this.state?.clearanceRecordsFilter?.selectedShow : null)
                                                        this.handleChange('season_id', null)
                                                        this.handleChange('show_season_id', null)
                                                        this.handleChange('show_season_episode_id', null)
                                                        this.handleChange('episode_title', null)
                                                        this.setState({ seasonOptions: [], episodeOptions: [], division_id: newValue ? newValue?.division_id : null })
                                                        if (newValue) {
                                                            this.getSeasons(newValue.value);
                                                        }
                                                    }}
                                                    searchText={ev => {
                                                        if (ev.target.value !== "" && ev.target.value !== null) {
                                                            this.getShowLists(ev.target.value)
                                                        }

                                                    }}
                                                />
                                            </MDBCol>
                                            <MDBCol md={4}></MDBCol>
                                        </MDBRow>
                                        <MDBRow className="mt-1">
                                            <MDBCol md={2}>
                                                {(this.state.isFetchingSeason) ? <CircularProgress color="inherit" size={15} /> :
                                                    <SelectField
                                                        width={"100%"}
                                                        label="Season"
                                                        placeHolderText="- Select -"
                                                        isMandatory={true}
                                                        showMandatory={this.state.postInitiated}
                                                        mandatoryWarning={messages.mandatoryWarning}
                                                        value={data.season_id?data.season_id:this.state?.clearanceRecordsFilter?.selectedSeason?this.state?.clearanceRecordsFilter?.selectedSeason:null}
                                                        options={this.state.seasonOptions || []}
                                                        onChange={(e) => {
                                                            this.handleChange("season_id", e.target.value)
                                                            this.handleChange("show_season_episode_id", null);
                                                            this.handleChange("episode_title", null)
                                                            let selectedShowSeason = this.state.seasonOptions?.find(item => item?.value === e.target?.value)?.show_season_id
                                                            this.handleChange("show_season_id", selectedShowSeason ? selectedShowSeason : null)
                                                            this.setState({ episodeOptions: [] })
                                                            if (selectedShowSeason != "") {
                                                                this.setState({ loadingEpisodes: true })
                                                                this.getShowBasedEpisodes(selectedShowSeason)
                                                            }
                                                        }
                                                        }
                                                    />
                                                }
                                            </MDBCol>
                                            <MDBCol md={4}>
                                                {(this.state.loadingEpisodes) ? <CircularProgress color="inherit" size={15} /> :
                                                    <SelectField
                                                        label={"Episode"}
                                                        width={"100%"}
                                                        id={"episode"}
                                                        placeHolderText="- Select -"
                                                        isMandatory={true}
                                                        showMandatory={this.state.postInitiated}
                                                        mandatoryWarning={messages.mandatoryWarning}
                                                        value={data.show_season_episode_id?data.show_season_episode_id:this.state?.clearanceRecordsFilter?.selectedEpisode?this.state?.clearanceRecordsFilter?.selectedEpisode:null}
                                                        options={this.state.episodeOptions || []}
                                                        onChange={(e, newValue) => {
                                                            this.handleChange("show_season_episode_id", e.target.value);
                                                            this.handleChange("episode_title", newValue?.props?.children)
                                                        }}
                                                    />
                                                }
                                            </MDBCol>
                                        </MDBRow>
                                    </div>
                                }
                                {this.state.durationValid === false ? <p className="f-color">Please enter Duration in format : max. 3 digits:max 2 digits</p> : null}
                                {(this.state.loadingSongs) ?
                                    <CircularProgress color="inherit" size={15} />
                                    :
                                    this.state.clearanceRecordData?.songs_list?.map((song, index, array) => (
                                        <>
                                        <MDBRow key={"dropdownrow" + index}>
                                            <MDBCol className="songsDropdown" md={4} disabled={this.state.songListData[index]?.song_id === song.song_id ? true : false}>
                                                <BasicLabel
                                                    text="Song"
                                                />
                                                <SearchFieldWithAddValue
                                                    id={"songs" + index}
                                                    //label={`${index === 0 ? "Song(s)" : ""}`}
                                                    placeholder={'- Search -'}
                                                    width={'100%'}
                                                    //value={this.state?.selectSong}
                                                    isMandatory={true}
                                                    showMandatory={this.state.postInitiated}
                                                    mandatoryWarning={messages.mandatoryWarning}
                                                    loading={this.state.isSongFetching[index]}
                                                    detail_selected={song?.song_title && song?.song_title?.trim() !== "" ? song?.song_title : this.state?.proposedNewSong?.value}
                                                    options={this.state.songOptions || []}
                                                    searchSelect={this.state.searchSelect}
                                                    onChange={(e, newValue) => this.handleSongDataChange("song", newValue, index)}
                                                    searchText={ev => {
                                                        // dont fire API if the user delete or not entered anything
                                                        if (ev.target.value !== "" && ev.target.value !== null) {
                                                            this.getSongs(ev.target.value, index)
                                                        }
                                                    }}

                                                    newLabel={'Song'}
                                                    displayAddNewSongOption={this.state.displayAddNewSongOption}
                                                    onDropdownClose = {this.onDropdownClose.bind(this)}
                                                />
                                                {
                                                    this.state.songUse[index] === 1
                                                        ?
                                                        <span>
                                                            <span class="donot"><i>DO NOT USE song</i> </span>
                                                        </span>
                                                        : ""
                                                }
                                            </MDBCol>
                                            <MDBCol md={3} id="performer">
                                                <>
                                                    <BasicLabel
                                                        text="Performer"
                                                    // isMandatory={true}
                                                    />
                                                    {/* disabled={(!song.song_id || this.state.songListData[index]?.song_id === song.song_id)?true:false}> */}
                                                    {song?.songLoader ? <CircularProgress size={15} /> :
                                                        <SearchFieldWithAddValue
                                                            id={"performer"}
                                                            newLabel={`${index === 0 ? "Perfomer" : ""}`}
                                                            placeholder={'- Search -'}
                                                            // isMandatory={true}
                                                            // showMandatory={this.state.postInitiated}
                                                            // mandatoryWarning={messages.mandatoryWarning}
                                                            options={song?.song_id?this.state.performerOptions[index] || []:this.state.performerOptions || []}
                                                            searchSelect={true}
                                                            detail_selected={song?.selected_performer}
                                                            onChange={(e, newValue) => this.handleSongDataChange("performer", newValue, index)}
                                                            searchText={ev => {
                                                                if (ev.target.value !== "" && ev.target.value !== null) {
                                                                    this.getPerformerDetails(ev.target.value, index)
                                                                } else {
                                                                    let flags = [...this.state.isPerformerFetching]
                                                                    flags[index] = false
                                                                    this.setState({ isPerformerFetching: flags })
                                                                }
                                                            }}
                                                        />}
                                                </>
                                            </MDBCol>
                                            {this.state.useOptions?.find(item => item?.value === song.music_uses_id)?.label !== 'Custom Use' ? 
                                            <MDBCol md={2} className='flex justify-content-between'>
                                                <BasicTextField
                                                    label="Min"
                                                    placeholder={"__"}
                                                    value={song.min}
                                                    fieldValid={song.min ? !validateNumbersOnly(song.min) : false}
                                                    inValidInput={"Invalid Min."}
                                                    onChange={(e) => this.handleSongDataChange("min", e.target.value.length > 0 ? e.target.value : null, index)} />
                                                <BasicTextField
                                                    value={':'}
                                                    label={`${index === 0 ? " " : ""}`}
                                                    showAsLabel={true} />
                                                <BasicTextField
                                                    label="Sec"
                                                    placeholder={"__"}
                                                    value={song.sec}
                                                    fieldValid={song.sec ? !(validateNumbersOnly(song.sec) && song.sec < 60) : false}
                                                    inValidInput={"Invalid Sec."}
                                                    onChange={(e) => this.handleSongDataChange("sec", e.target.value.length > 0 ? e.target.value : null, index)} />
                                            </MDBCol> :
                                                <MDBCol md={2}>
                                                    <BasicLabel text={'Duration'} />
                                                    <BasicButton
                                                        onClick={(e) => this.handleSongDataChange("customPopover", e.currentTarget, index)}
                                                        variant="outlined"
                                                        text={"View"}
                                                    />
                                                    <Popover
                                                        id={index + song?.music_uses_id}
                                                        open={Boolean(song?.customPopover)}
                                                        anchorEl={song?.customPopover}
                                                        getContentAnchorEl={null}
                                                        onClose={() => this.handleSongDataChange("customPopover", null, index)}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'left',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'left',
                                                        }}
                                                        PaperProps={{
                                                            style: {
                                                                width: '30%',
                                                                borderRadius: '1px',
                                                            }
                                                        }}
                                                    >
                                                        <BasicTextArea
                                                            label={""}
                                                            rows={5}
                                                            value={this.state.customNotes || null}
                                                            onChange={(e) =>
                                                                this.setState({ customNotes: e.target.value?.length > 0 ? e.target.value : null })
                                                            }
                                                        />
                                                        <MDBRow className="mt-2">
                                                            <MDBCol md={8}>
                                                                <BasicButton
                                                                    text={"Sync Use Only"}
                                                                    onClick={() => {
                                                                        let currentString = this.state.customNotes
                                                                        currentString = currentString ? currentString?.includes('SYNC:') ? currentString : 'SYNC: ' + currentString : 'SYNC: '
                                                                        this.setState({ customNotes: currentString })
                                                                    }}
                                                                />
                                                            </MDBCol>
                                                            <MDBCol md={4}>
                                                                <BasicButton
                                                                    text={"OK"}
                                                                    onClick={() => {
                                                                        this.handleSongDataChange("custom_use", this.state.customNotes, index)
                                                                    }}
                                                                />
                                                            </MDBCol>
                                                        </MDBRow>
                                                        <MDBRow className="mt-2">
                                                            <MDBCol md={8}>
                                                                <BasicButton
                                                                    text={"Master Use Only"}
                                                                    onClick={() => {
                                                                        let currentString = this.state.customNotes
                                                                        currentString = currentString ? currentString?.includes('MASTER:') ? currentString : currentString + '\nMASTER: ' : '\nMASTER: '
                                                                        this.setState({ customNotes: currentString })
                                                                    }}
                                                                />
                                                            </MDBCol>
                                                            <MDBCol md={4}>
                                                                <BasicButton onClick={() => this.handleSongDataChange("customPopover", null, index)} variant="outlined" text={"Cancel"} />
                                                            </MDBCol>
                                                        </MDBRow>
                                                    </Popover>
                                                </MDBCol>}
                                            <MDBCol md={2} id="music_use">
                                                <SelectField
                                                    label="Use"
                                                    isMandatory={true}
                                                    showMandatory={this.state.postInitiated}
                                                    mandatoryWarning={messages.mandatoryWarning}
                                                    placeHolderText={"- Select - "}
                                                    value={song.music_uses_id}
                                                    options={this.state.useOptions?.filter(item => item?.is_active === 1 || item?.value == song.music_uses_id) || []}
                                                    onChange={(e) => this.handleSongDataChange("music_uses_id", e.target.value, index)}
                                                />
                                            </MDBCol>
                                            <MDBCol md={1} className={index === 0 ? "align-end" : "self-center align-end"}>
                                                <div className="add-remove-icons">
                                                    <div>
                                                        {!(data.songs_list.length === 1)
                                                            ? <RemoveCircleIcon fontSize="small" onClick={() => this.removeField("song",index)} />
                                                            : null
                                                        }
                                                    </div>
                                                    <div className="ml5">
                                                        {
                                                            data.songs_list.length - 1 === index && song.song_id != null ?
                                                                <AddCircleIcon fontSize="small" onClick={() => this.addField("song", index)} />
                                                                : null
                                                        }
                                                    </div>
                                                    {this.state.inActiveSongFeatching && (index === array.length - 1) ? 
                                                        <div style={{ textAlign: "center" }}>
                                                            <CircularProgress size={20} />
                                                        </div> :
                                                            this.state.openInActiveSongModal &&(
                                                                <MessageModal
                                                                open={this.state.openInActiveSongModal}
                                                                title={"Message"}
                                                                message={songStatus}
                                                                hideCancel={false}
                                                                primaryButtonText={"OK"}
                                                                secondaryButtonText={"Cancel"}
                                                                onConfirm={() => this.onConfirmInActiveSong()}
                                                                handleClose={(e) => this.onCloseInActiveSong()}
                                                                />
                                                            )
                                                        }
                                                </div>
                                            </MDBCol>
                                        </MDBRow>
                                        <MDBRow>
                                            <MDBCol md={4}> 
                                                {
                                                    song?.writer?.map((writer, index2) => (
                                                        (writer?.song_writer_is_delete === 0 ? <>
                                                            <MDBCol md={8} className={"col-content d-inline-block"} id="writer">
                                                                {song?.songLoader ? <CircularProgress size={15} /> :
                                                                <SearchSelectField
                                                                    id={"writer-select"}
                                                                    label={index2 === 0 ? "Writers" : ""}
                                                                    options={song?.song_id ? this.state.writerOptions[index] || [] : this.state.writerOptions || []}
                                                                    multiple={false}
                                                                    //detail_selected={writer?.selected_writer ? writer?.selected_writer : null}
                                                                    detail_selected={writer?.writer_id && writer?.writer_name ? {
                                                                value: writer?.writer_id,
                                                                text: writer?.writer_name
                                                            } : null}
                                                                    valueSelected={(e,newValue)=> {
                                                                        this.handleSongDataChange('writer', newValue || null, index2,null,index)
                                                                        let writerOptions = [...this.state.writerOptions];
                                                                        writerOptions[index] = this.state.writerList[index] || [];
                                                                        this.setState({ writerOptions });
                                                                    }}
                                                                    searchText={(e, value) => {
                                                                        if (e.target.value !== "" && e.target.value !== null) {
                                                                            this.getWriterList(e.target.value, index2, index)
                                                                        } 
                                                                    }}
                                                                    searchSelect={true}
                                                                />}
                                                            </MDBCol>
                                                            <MDBCol md={4} className="actionButons2 d-inline-block">
                                                                <MDBRow>
                                                                    { //this.state?.editWriterNamePermission && !writer?.writer_id &&
                                                                        <MDBCol md={1} className='pensquareicon'>
                                                                            <MDBIcon
                                                                                icon={'pen-square'}
                                                                                disabled={!writer?.writer_id ? true : false}
                                                                                onClick={(e) => {
                                                                                    writer?.writer_id?
                                                                                    this.setState({
                                                                                        writerMode: writer?.writer_id ? {
                                                                                            value: writer?.writer_id,
                                                                                            text: writer?.temp_writer_name,

                                                                                        } : 'new', selectedWriterIndex: index, selectedSongIndex: index2
                                                                                    }):null
                                                                                }}
                                                                            />
                                                                        </MDBCol>
                                                                    }
                                                                    <MDBCol className={"removeActionIcon"} md={1}>
                                                                        {
                                                                            (writer.writer_name?.length > 0) ?
                                                                                <RemoveCircleIcon
                                                                                    onClick={(e) =>
                                                                                        this.removeField("writer", index2, index)
                                                                                    }
                                                                                />
                                                                                : null
                                                                        }
                                                                    </MDBCol>
                                                                    <MDBCol className={this.state.songDetails?.writer?.length === 1 ? 'notDisabled addIconMargin' : 'notDisabled'} md={1}>
                                                                        {
                                                                            (writer.writer_name?.length > 0 && index2 === (song?.writer?.length - 1)) ?
                                                                                <AddCircleIcon onClick={(e) => this.addField("writer", index2, index)}/> 
                                                                                : 
                                                                                null
                                                                        }
                                                                    </MDBCol>
                                                                </MDBRow>
                                                                </MDBCol>
                                                        </> : null)
                                                    ))
                                                }
                                            </MDBCol>
                                            <MDBCol md={7}>
                                                <BasicTextArea
                                                    label="Scene"
                                                    rows={3}
                                                    value={song?.scene || null}
                                                    onChange={(e) => this.handleSongDataChange("scene", e.target.value?.length > 0 ? e.target.value : null, index)}
                                                />
                                                <MDBRow className="songCheckboxContainer">
                                                    <BasicCheckbox
                                                        id={"is_library"+index}
                                                        label="Library"
                                                        align="end"
                                                        checked={song?.is_library}
                                                        onChange={(e) => this.handleChange("is_library", e.target.checked,index)}
                                                    />
                                                    <BasicCheckbox
                                                        id={"song_is_do_not_use"+index}
                                                        label="Do not Use"
                                                        align="end"
                                                        checked={song?.is_do_not_use}
                                                        onChange={(e) => this.handleChange("is_do_not_use", e.target.checked,index)}
                                                    />
                                                    <BasicCheckbox
                                                        id={"is_studio_owned"+index}
                                                        label="Studio Owned"
                                                        align="end"
                                                        checked={song?.is_studio_owned}
                                                        onChange={(e) => this.handleChange("is_studio_owned", e.target.checked,index)}
                                                    />
                                                    <BasicCheckbox
                                                        id={"is_contains_sample"+index}
                                                        label="Contains Sample(s)"
                                                        align="end"
                                                        checked={song?.is_contains_sample}
                                                        onChange={(e) => this.handleChange("is_contains_sample", e.target.checked,index)}
                                                    />
                                                    {/* <BasicCheckbox
                                                        id={"is_pd"+index}
                                                        label="Public Domain"
                                                        align="end"
                                                        checked={song?.is_CR_PD}
                                                        //disabled={this.props?.mode === "Edit" ? true : false}
                                                        onChange={(e) => this.handleChange("is_CR_PD", e.target.checked,index)}
                                                    /> */}
                                                    <BasicCheckbox
                                                        id={"is_all_promo_use_restricted"+index}
                                                        label="No Promo Use Allowed"
                                                        align="end"
                                                        checked={song?.is_all_promo_use_restricted}
                                                        onChange={(e) => {
                                                            this.handleChange("is_all_promo_use_restricted", e.target.checked,index)
                                                        }}
                                                    />
                                                    <BasicCheckbox
                                                        id={"is_arrangement"+index}
                                                        label="Is Arrangement"
                                                        align="end"
                                                        checked={song?.is_arrangement}
                                                        onChange={(e) => this.handleChange("is_arrangement", e.target.checked,index)}
                                                    />
                                                    <BasicCheckbox
                                                        id={"is_coa"+index}
                                                        label="COA"
                                                        align="end"
                                                        checked={song?.is_coa}
                                                        onChange={(e) => this.handleChange("is_coa", e.target.checked,index)}
                                                    />
                                                </MDBRow>
                                            </MDBCol>
                                        </MDBRow>
                                        </>
                                    ))}
                                <MDBRow className="mt-1">
                                    <MDBCol md={5}>
                                        <MDBRow className="mt-2">
                                            <MDBCol md={6} className="self-end">
                                                {((this.state?.isActiveMusicSupervisor || isMusicSupervisor)
                                                    ? this.state.checkBoxOptionsLeft.filter(obj => obj.id !== "is_override_cost_center")
                                                    : this.state.checkBoxOptionsLeft
                                                ).map((obj, index) => (
                                                    <BasicCheckbox key={index}
                                                        id={obj.id}
                                                        label={obj.label}
                                                        checked={data[obj.id] === 1}
                                                        onChange={(e) => this.onCheckboxChange(e.target.checked, obj.id)}
                                                    />
                                                ))}
                                            </MDBCol>
                                            <MDBCol md={6} className="self-end">
                                                {checkBoxOptionsRight.map((obj, index) => (
                                                    <BasicCheckbox key={index}
                                                        id={obj.id}
                                                        label={obj.label}
                                                        checked={data[obj.id] ? true : false}
                                                        onChange={(e) => this.onCheckboxChange(e.target.checked, obj.id)}
                                                        disabled={obj.id === "is_apply_dollar_to_HV" ? !editApplyHVPermission : false}
                                                    />
                                                ))}
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCol>
                                    <MDBCol md={2} >
                                        <BasicLabel text="Ad Card" />
                                        <SelectField
                                            placeHolderText="-Select-"
                                            value={data.clearance_option_id || []}
                                            options={this.state.adCardOptions || []}
                                            onChange={(e, newValue) => {
                                                this.handleChange("clearance_option_id", e.target.value);
                                                this.handleChange("clearance_option", newValue?.props?.children)
                                            }
                                            }
                                        />
                                    </MDBCol>

                                </MDBRow>
                                <br />
                                <MDBRow>
                                    <MDBCol md={10}></MDBCol>
                                    <MDBCol md={2}>
                                        <MDBRow>
                                            <MDBCol>
                                                <BasicButton text={this.state.isPosting ? <CircularProgress color="inherit" size={20} /> : this.props?.mode === "Edit" ? "Save" : "Create"} onClick={this.handleSubmit} disabled={this.props?.viewNewCRPermission?.edit === 1 ? false : true} />
                                            </MDBCol>
                                            <MDBCol>
                                                <BasicButton onClick={() => this.props?.handleClose()} variant="outlined" text={"Cancel"} />
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCol>
                                </MDBRow>
                            </MDBContainer>
                        </div>
                    )
                }   
                {
                    this.state.isEditingPerformer &&
                        <MainViewModalComponent
                            open={this.state.isEditingPerformer}
                            handleClose={this.handleCloseEditSongModal.bind(this)}
                            headerText={"Song"}
                            mode={"Edit"}
                            modalName={"Song"}
                            songId={this.state.clearanceRecordData.songs_list[this.state.editingPerformerSongIndex]?.song_id}
                            commonPermissions={this.props?.userContext?.active_tenant?.common_permissions}
                            toggleRefreshPage={this.props?.toggleRefreshPage}
                            division_id={this.props?.division_id}
                            toggleRefreshMainTitleLicensor={this.props?.toggleRefreshMainTitleLicensor}
                            handleFilterSearch = {this.props.handleFilterSearch}
                            origin={"fromPerformerEdit"}                  
                            selectedPerformer={this.state.newPerformerData || { performer: this.state.clearanceRecordData.songs_list[this.state.editingPerformerSongIndex]?.selected_performer }}
                            selectedPerformerIndex = {this.state.editingPerformerSongIndex}
                            handleSongDataChange={this.handleSongDataChange.bind(this)}    
                        />                                           
                }             
                <Popover
                    open={this.state.newSongPopup}
                    getContentAnchorEl={null}
                    onClose={() => this.newSongPopup()}
                    anchorOrigin={{
                        vertical: '5%',
                        horizontal: 'center',
                    }}
                    anchorPosition={{ top: 100 }}
                    transformOrigin={{
                        vertical: '5%',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        style: {
                            width: '70%',
                            borderRadius: '1px',
                            padding:'0px'
                        }
                    }}
                >
                    <EditSongDetails
                        songId={this.props?.songId}                        
                        mode={"new"}
                        fieldChanged={this.props?.fieldChanged}
                        setPostFlag={this.props?.setPostFlag}
                        handleClose={this.newSongPopup.bind(this)}
                        notificationComponent={this.props?.notificationComponent}
                        toggleRefreshPage={this.props?.toggleRefreshPage}
                        //toggleRefreshMainTitleLicensor={this.props?.toggleRefreshMainTitleLicensor}
                        PopoverTitle={"New Song"}                        
                        songModalPermissions={this.props?.episodeSongPermissions ? this.props?.episodeSongPermissions : this.props?.commonPermissions?.find(item => item.permission_group_name == "Songs")}
                        proposedNewSong={this.state.proposedNewSong?.value}
                        newSongId={this.newSongId.bind(this)}
                        editPerformer = {this.state.isEditingPerformer}
                        newSongRowIndex={this.state.newSongRowIndex}
                        origin="clearanceRecord"
                        isDuplicateSong={this.state?.isDuplicateSong}
                        // selectedPerformerIndex = {this.state.selectedPerformerIndex}
                        // handleSongDataChange={this.handleSongDataChange}                                     
                    />    
                    {/* this.getPerformer(songId, index, selectedPerformerId); */}
                </Popover>
                {this.state.writerMode && <MainViewModalComponent
                    open={this.state.writerMode ? true : false}
                    handleClose={() =>
                        this.setState({
                            writerMode: null,
                            selectedWriterIndex: null,
                        })
                    }
                    headerText={"Writer"}
                    mode={this.state.writerMode !== 'new' ? "Edit" : 'Add'}
                    writerId={this.state.writerMode || null}
                    modalName={"On Fly Lookup"}
                    type={'writer'}
                    division_id={this.state?.division_id}
                    handleAddWriter={(writerData) => {
                        let index = this.state.selectedWriterIndex
                        let index2 = this.state.selectedSongIndex
                        this.handleSongDataChange('writer', writerData || null, index2,null,index)
                    }}
                    origin="clearanceRecord"
                    songDetails={this.state.clearanceRecordData?.songs_list?.[this.state.selectedSongIndex]?.writer?.[this.state.selectedWriterIndex] || null}
                    songId={this.props?.songId}
                    selectedWriterIndex = {this.state.selectedWriterIndex}
                    selectedSongIndex = {this.state.selectedSongIndex}
                />}      
                <NotificationComponent
                    open={this.state.showDuplicateNotification}
                    message={`The performer "${this.state?.duplicatePerformerName}" already exists. Cannot add a duplicate.`}
                    severity={"error"}
                    handleResetNotify={this.handleResetNotify.bind(this)}
                />
                {this.state.warningNotesModal?.open &&
                    <WarningNotesModal
                        {...this.state.warningNotesModal}
                        onConfirm={() => this.handleWarningNotesModalConfirm()}
                        handleClose={() => this.handleWarningNotesModalConfirm()}
                    />
                }
            </>
        );
    }
}
export default withUserContext(ClearanceRecord);